import { ATKOMST_TEAMS_EDITOR_PERMISSION } from "../../shared/types/atkomstPermissions";
import useUserAtkomstPermissions from "../../login/hooks/useUserAtkomstPermissions";
import RoleType from "@coworker/enums/roleType";
import { useLoggedInUser } from "@coworker/app/src/core/auth/useLoggedInUser";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

/*
 * Once we remove admin, we can delete this complexity and only call const { data: atkomstPermissions } = useUserAtkomstPermissions(storeId);
 * TO-DO: COAPP-12886
 */

const useHasTeamEditorPermissions = (storeId?: string) => {
  const { getRoleId } = useLoggedInUser();
  const roleId = getRoleId();
  const enableAtkomst = useFlag(FLAGS.ENABLE_ATKOMST);

  const { data: atkomstPermissions, isLoading } =
    useUserAtkomstPermissions(storeId);
  const hasAtkomstTeamsEditorPermissions = !!atkomstPermissions?.includes(
    ATKOMST_TEAMS_EDITOR_PERMISSION
  );

  const hasAllowedRole = [
    RoleType.STOREOWNER,
    RoleType.COUNTRY_SUPERUSER,
    RoleType.SUPERUSER,
  ].includes(roleId);

  const hasPermission = enableAtkomst
    ? hasAtkomstTeamsEditorPermissions
    : hasAllowedRole;

  return { hasPermission, isLoading: enableAtkomst ? isLoading : false };
};

export default useHasTeamEditorPermissions;
